import {$, w} from './constants';

const HEADER = $('.header');
const LOGO = $("#logo_header");
const menu_tl = gsap.timeline();
const colors = ['#33FF00', '#F000FF', '#3C53E6', '#7B1DFF', '#FE6700', '#FFFF04'];
const colorsReviews = ['#33FF00', '#F000FF', '#3C53E6', '#7B1DFF', '#FE6700'];
w.load(() => {
    console.log('Hello world from El Cultivo! --Load');

    /* M E N Ú */
    w.on('scroll', function(){
        if($(this).scrollTop() > HEADER.height()){
            HEADER.addClass('active');
        }else{
            HEADER.removeClass('active');
        }
    });
    ScrollTrigger.matchMedia({
        // Tablets & mobile
        "(max-width: 951px)": function() {
            menu_tl.to(LOGO, {
                scale: .68,
                top: '-14px',
                ease: 'none',
                scrollTrigger : {
                    trigger: HEADER,
                    scrub: 1,
                    start : "start",
                    end : `bottom`,
                    markers : false
                }
            });

            $('.show_submenu').on('click', function(){
                $(this).parent().siblings('.submenu').slideToggle(200);
                $(this).toggleClass('active');
            })
        }
    });
    $('#trigger_menu').on('click', function(){
        $('#target_menu').fadeIn(500).addClass('active');
    });
    $('#close_menu').on('click', function(){
        $('#target_menu').fadeOut(200).removeClass('active');
    });

    let currentUrl = window.location.href;
    
    $('.menu_link').each(function() {
        let linkUrl = $(this).attr('href');
        if (currentUrl === linkUrl) {
            $(this).addClass('current-page');
        }
    });
    $('.menu_link_tax').each(function() {
        if (currentUrl.includes('zonas')) {
            $(this).parent().parent().parent().siblings('.main_link-container').children('.menu_link_tax_m ').addClass('current-page');
        }
    });
    /* END M E N Ú */

    /* B Ú S Q U E D A */
    $('.search_desktop').on('click', function(){
        $('.search_desktop_target').fadeToggle(300);
    });
    $('.search_mobile').on('click', function(){
        $('.search_mobile_target').fadeToggle(300);
    });
   
    if( $(w).width() > 1024){
        const searchInput = document.querySelector('input.input--search-nav');
        if (searchInput.value) {
            searchInput.closest('.header__search-container').classList.add('active');
        }
    }

    /* END B Ú S Q U E D A */

    /* F E A T U R E D  C A R D */
    if ($('#featured_card').length) {
        let ideal_height = $('.has_featured_card').height();
        let img = $('#featured_card > .image-container').height();
        let data =  $('#featured_card > .data-container').height();
        let card = img + data;
        if( (card < ideal_height) && (w.width() > 1041 ) ){
            let min_height = ideal_height - data;
            $('#featured_card > .image-container').css('min-height', `${min_height}px`);
        }
    }
    /* /END F E A T U R E D  C A R D */

    /* F I L T E R */
    $('[data-filter]').on('click', function(){
        $('[data-filter].active').removeClass('active');
        $('[data-filter-target].active').removeClass('active');
        let target = $(this).data('filter');
        $(this).addClass('active');
        $(`[data-filter-target="${target}"]`).addClass('active');
    });
    if ($('#filters_grid').length) {
        let blocks = $('#filters_grid').find('.home-template__explore-grid-block');
        let min_height, height_prev, height_current;
        blocks.each(function (i, element) {
            if (i != 0) {
                height_prev = blocks.eq(i - 1).height();
                height_current = $(this).height();
                if (height_prev <= height_current) {
                    min_height = height_current;
                } else {
                    min_height = height_prev;
                }
            }else{
                min_height = $(this).height();
            }
        });
        /* min_height = min_height + titles + 140; */
        $('#filters_grid').css('min-height', `${min_height}px`);
    }    
    /* END F I L T E R */
});

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');
    /* O R D E R */
    $('.btn--filter-grid').on('click', function(){
        $('#order-posts').fadeToggle(200);
    });
    $('input[name="order"]').change(function() {
        var order = $(this).val();
        $('input[name="order"]').parent().removeClass('checked');
        $(this).parent().addClass('checked');
        $('#order-post-current').text($(this).data('title'));
        $.ajax({
            type: 'POST',
            dataType: 'html',
            url: cltvo_js_vars.ajax_url,
            data: { 
                action : 'order', 
                order: order
            },
            success: function(data){
                $('#grid_container').html(data);
                $('#order-posts').fadeOut(100);
            },
            error: function(errors){
                console.log( errors );
            }
        });
    });
    /* END O R D E R */

    /* R E T U R N */
    $('#back_page_single').on('click', function(){
        window.history.back();
    });
    $('.back_page').on('click', function(){
        window.history.back();
    });
    /* END R E T U R N */

    /* Z O N E S */
    const slider = document.querySelector('.slider--grab');
    let isDown = false;
    let startX;
    let scrollLeft;

    if(slider){
        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mousemove', (e) => {
            if(!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 3; //scroll-fast
            slider.scrollLeft = scrollLeft - walk;
        });
         // Función para mostrar u ocultar las flechas de la galería
         function toggleGalleryArrows() {
            var gallery = $('.slider--grab');
            var arrows = $('.gallery_arrows');
            var totalWidth = 0;
            gallery.children().each(function() {
                totalWidth += $(this).outerWidth(true); // Incluye márgenes y bordes
            });

            // Verificar si el ancho total de los elementos es mayor que el ancho del contenedor
            if (totalWidth > gallery.width()) {
                arrows.show(); // Mostrar flechas si el ancho total es mayor
            } else {
                arrows.hide(); // Ocultar flechas si el ancho total es igual o menor
            }
        }

        // Llamar a la función al cargar la página y al redimensionar la ventana
        toggleGalleryArrows();

        $(window).resize(function() {
            toggleGalleryArrows();
        });
    }

    if($('#terms_container').length){
        // Selecciona el contenedor de los elementos
        let container = $('#terms_container');

        // Encuentra el elemento con la clase "active" y muévelo al principio
        container.prepend(container.find('.card__block.active'));
    }
    /* END Z O N E S */

    /* B U T T O N  C O L O R S */
    if( $('#grid_colors').length ){
        renderColors($('#grid_colors .card__restaurant-block'));
    }
    if( $('#grid_colors_zones').length ){
        renderColors($('#grid_colors_zones .card__restaurant'));
    }
    
    if( $('#grid_results').length ){
        renderColors($('#grid_results .search-card'));
    }

    if( $('#grid_empty_results').length ){
        renderColors($('#grid_empty_results .search-card'));
    }
    if( $('#grid-reviews-collaborator').length ){
        renderColors($('#grid-reviews-collaborator .card__restaurant-review'));
    }
    if( $('#restaurant_reviews').length ){
        let colorIndex = 0;

        $('#restaurant_reviews .card__review').each(function() {
            // Obtener el botón dentro de este bloque
            let $button = $(this).find('.toggle_read');
            
            // Asignar el color de fondo al botón
            $button.css('color', colorsReviews[colorIndex]);
            
            // Incrementar el índice de color o reiniciar si alcanza el límite
            colorIndex = (colorIndex + 1) % colorsReviews.length;
        });
    }
    /* END B U T T O N  C O L O R S */

    /* R E A D  M O R E */
    $('.read_more').on('click', function(){
        $(this).parent().slideUp(100);
        $(this).parent().siblings('.description-desktop').slideDown(100);
    });
    $('.read_less').on('click', function(){
        $(this).parent().slideUp(100);
        $(this).parent().siblings('.description-mobile').slideDown(100);
    });
    $('.read_more_review').on('click', function(){
        $(this).parent().slideUp(100);
        $(this).parent().siblings('.data-container-full').slideDown(100);
    });
    $('.read_less_review').on('click', function(){
        $(this).parent().slideUp(100);
        $(this).parent().siblings('.data-container-trimmed').slideDown(100);
    });
    /* END R E A D  M O R E */

    /* L O A D M O R E */
    $('#grid_collaborator_load_btn').on('click', function(){
        let collaborator = $(this).data('collaborator');
        let post_id =  $(this).data('post');
        let classes =  $(this).data('class');
        call_guides_load(collaborator, post_id, classes);
    });
    /* END L O A D M O R E */
});

/* L O A D M O R E */
let pager = 1;
let request = true;
const call_guides_load = ( collaborator = null, post_id = null, classes = null) => {
  if (request) {
    request = false;
    $.ajax({
      type: 'POST',
      dataType: 'html',
      url: cltvo_js_vars.ajax_url,
      data: { 
          action : 'load', 
          page: pager,
          id: collaborator,
          post_id: post_id,
          class: classes
      },
      success: function(data){
        pager+=1;
        $('#grid_collaborator').append( data );
        onAjaxDone(data);
        $('#grid_collaborator_load_btn').on('click', function(){
            let collaborator = $(this).data('collaborator');
            let post_id =  $(this).data('post');
            call_guides_load(collaborator, post_id);
        });
      },
      error: function(errors){
        console.log( errors );
      }
    });
  }
}
let onAjaxDone = function() {
  if ($('#max_pages').val() == pager ) {
    let buttons = document.querySelectorAll('.single-guide__related-load');
    Array.from(buttons).forEach( btn => {
      $(btn).css('display', 'none');
    })
    request = false;
  }else{
    let buttons = document.querySelectorAll('.single-guide__related-load');
    Array.from(buttons).forEach( btn => {
      $(btn).css('display', 'none');
    })
    let btn_last = buttons[buttons.length - 1];
    $(btn_last).css('display', 'flex');
    request = true;
  }

}
/* END L O A D M O R E */

/* A J A X  S E A R C H */
$("input#search_home").keyup(function(event) {
    if ($(this).val().length > 2) {
        $('#search_home').siblings('.btn').addClass('go');
        getSearch($(this).val(), '', $('#search_home_container'));
    }else if($(this).val().length > 1 ||  $(this).val().length == 0) {
        $('#search_home').siblings('.btn').removeClass('go');
        $('#search_home_container').html('');
    }
});
if( $('#search_home').length ){
    const searchInput = document.getElementById('search_home');
    searchInput.addEventListener('input', function(event) {
        if (event.target.value === '') {
            $('#search_home').siblings('.btn').removeClass('go');
            $('#search_home_container').html('');
        }
    });
}
$("input.input--search-nav").keyup(function(event) {
    if ($(this).val().length > 2) {
        let classCss = $(this).data('class');
        $('.search_nav_container_general').find('.btn').addClass('go');
        getSearch($(this).val(), classCss, $('.search_nav_container'));
    }else if($(this).val().length > 1 ||  $(this).val().length == 0) {
        $('.search_nav_container_general').find('.btn').removeClass('go');
        $('.search_nav_container').html('');
    }
});
if( $('.input--search-nav').length ){
    const searchInputs = document.querySelectorAll('.input--search-nav');
    searchInputs.forEach(function(searchInput) {
        searchInput.addEventListener('input', function(event) {
            if (event.target.value === '') {
                $('.search_nav_container_general').find('.btn').addClass('go');
                $('.search_nav_container').html('');
            }
        });
    });
    
}

function getSearch ( keywords, classCss = '', container ) {
    
    $.ajax({
        type: 'POST',
        dataType: 'html',
        url: cltvo_js_vars.ajax_url,
        data: { 
            action : 'autocomplete', 
            keywords: keywords,
            class: classCss
        },
        success: function(data){
            $(container).empty().append(data);
        },
        error: function(errors){
            console.log( errors );
        }
    });
}
/* END A J A X  S E A R C H */

/* F I L T E R  S E A R C H  E M P T Y */
$('.filter_search_empty').on('click', function(){
    let post_type = $(this).data('filter-search');
    $('.filter_search_empty.active').removeClass('active');
    $(this).addClass('active');
    getEmptyFilterSearch( post_type );
    let container = $('#filters_empty');
    container.prepend(container.find('.active'));
});
const getEmptyFilterSearch = ( post_type = null ) =>{
    $.ajax({
        type: 'POST',
        dataType: 'html',
        url: cltvo_js_vars.ajax_url,
        data: { 
            action : 'filter_empty', 
            post_type: post_type
        },
        success: function(data){
            $('#grid_empty_results').empty().append(data);
            renderColors($('#grid_empty_results .search-card'));
        },
        error: function(errors){
          console.log( errors );
        }
      });
}
/* END F I L T E R  S E A R C H  E M P T Y */

/* F I L T E R  S E A R C H */

let request_search = true;
$('.filter_search').on('click', function(){
    let post_type = $(this).data('filter-search');
    let keywords = $(this).data('filter-keyword');
    $('.filter_search.active').removeClass('active');
    $(this).addClass('active');
    let container = $('#filters_with_results');
    container.prepend(container.find('.active'));
    getFilterSearch( keywords, post_type, 1);
});
// Evento para el botón de página anterior
$('#prev_page').on('click', function() {
    let page_search = parseInt($(this).data('current-page')) - 1;
    let keywords = $(this).data('keywords');
    let post_type = $(this).data('filter-search');
    let max_pages = $(this).data('max-pages');
    getPageSearch(keywords, post_type, page_search, max_pages);
});

// Evento para el botón de página siguiente
$('#next_page').on('click', function() {
    let page_search = parseInt($(this).data('current-page')) + 1;
    let keywords = $(this).data('keywords');
    let post_type = $(this).data('filter-search');
    let max_pages = $(this).data('max-pages');
    getPageSearch(keywords, post_type, page_search, max_pages);
});

const updateResultsMessage = (start, end, total) => {
    $('.offset_current').text(start);
    $('.offset_next').text(end);
    $('.offset_counter').text(total);
}

//get_custom_search_results_paged($search_term, $post_type = null, $page = 1, $per_page = 2)
const getFilterSearch = ( search_term = null, post_type = null, page = 1) => {
    let per_page = $('#posts_per_page').val();
    if (request_search) {
        request_search = false;
      $.ajax({
        type: 'POST',
        dataType: 'html',
        url: cltvo_js_vars.ajax_url,
        data: { 
            action : 'filter', 
            page: 1,
            keywords: search_term,
            post_type: post_type,
            posts_per_page: per_page
        },
        success: function(data){
            $('#grid_results').empty().append(data);
            renderColors($('#grid_results .search-card'));
            let new_counter = parseInt($('#new_counter').val(), 10);
            let total_search = parseInt($('#total_search').val(), 10);
            console.log(total_search >= per_page);
            if( total_search >= per_page ){
                $('#prev_page').addClass('hide');
                $('#prev_page').data('keywords', search_term);
                $('#prev_page').attr('data-keywords', search_term);
                $('#prev_page').data('current-page', '1');
                $('#prev_page').attr('data-current-page', '1');
                $('#prev_page').data('max-pages', new_counter);
                $('#prev_page').attr('data-max-pages', new_counter);
                $('#prev_page').data('filter-search', post_type);
                $('#prev_page').attr('data-filter-search', post_type);

                $('#next_page').removeClass('hide');
                $('#next_page').data('keywords', search_term);
                $('#next_page').attr('data-keywords', search_term);
                $('#next_page').data('current-page', '1');
                $('#next_page').attr('data-current-page', '1');
                $('#next_page').data('max-pages', new_counter);
                $('#next_page').attr('data-max-pages', new_counter);
                $('#next_page').data('filter-search', post_type);
                $('#next_page').attr('data-filter-search', post_type);
                $('#grid_results_counter > .results_message').css('display' , 'block');
                $('#grid_results_counter > .results_message_empty').css('display' , 'none');

            }else{
                $('#next_page').addClass('hide');
                $('#prev_page').addClass('hide');
                if( new_counter == 0){
                    $('#grid_results_counter > .results_message').css('display' , 'none');
                    $('#grid_results_counter > .results_message_empty').css('display' , 'block');
                    $('#grid_results_counter > .results_message_empty > .offset-type').html( post_type );
                }else{
                    $('#grid_results_counter > .results_message').css('display' , 'block');
                    $('#grid_results_counter > .results_message_empty').css('display' , 'none');
                }
            }
            let start = 1;
            let end = Math.min(1 * per_page, $('#total_search').val());
            updateResultsMessage(start, end, $('#total_search').val());
        },
        error: function(errors){
          console.log( errors );
        },
        complete: function() {
            request_search = true; // Restablecer a true después de completar la solicitud
        }
      });
    }
}

const getPageSearch = ( search_term = null, post_type = null, page_search, max_pages) => {
    let per_page = $('#posts_per_page').val();
    if (request_search) {
        request_search = false;
        $.ajax({
            type: 'POST',
            dataType: 'html',
            url: cltvo_js_vars.ajax_url,
            data: { 
                action : 'filter', 
                page: page_search,
                keywords: search_term,
                post_type: post_type,
                posts_per_page: per_page
            },
            success: function(data){

                onAjaxDoneSearch(max_pages, page_search);
                $('#grid_results').empty().append(data);
                renderColors($('#grid_results .search-card'));
                let start = (page_search - 1) * per_page + 1;
                let end = Math.min(page_search * per_page, $('#total_search').val());
                updateResultsMessage(start, end, $('#total_search').val());


            },
            error: function(errors){
            console.log( errors );
            },
            complete: function() {
                request_search = true; // Restablecer a true después de completar la solicitud
            }
        });
    }
}
  let onAjaxDoneSearch = function( max_pages, page_search ) {
    
    $('#prev_page').data('current-page', page_search);
    $('#prev_page').attr('data-current-page', page_search);
    $('#next_page').data('current-page', page_search);
    $('#next_page').attr('data-current-page', page_search);

    if ( max_pages == page_search ) {
        console.log('Sin páginas que mostrar');
        $('#prev_page').removeClass('hide');
        $('#next_page').addClass('hide');
    }else if( page_search <= 1  ){
        $('#prev_page').addClass('hide');
        $('#next_page').removeClass('hide');
    }else{
        console.log('Mostrar más páginas');
        $('#prev_page').removeClass('hide');
        $('#next_page').removeClass('hide');
    }
  
  }
/* END F I L T E R  S E A R C H  */

/* B U T T O N  C O L O R S */
const renderColors = ( container ) =>{
    let colorIndex = 0;

    $(container).each(function() {
        // Obtener el botón dentro de este bloque
        let $button = $(this).find('.btn--zone-featured');
        
        // Asignar el color de fondo al botón
        $button.css('background-color', colors[colorIndex]);
        
        // Incrementar el índice de color o reiniciar si alcanza el límite
        colorIndex = (colorIndex + 1) % colors.length;
    });
}
/* END B U T T O N  C O L O R S */